'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');

var environment = {
  development: {
    isDev: true
  },
  production: {
    isDev: false
  }
}[process.env.NODE_ENV || 'development'];

module.exports = (0, _assign2.default)({
  host: process.env.HOST || 'localhost',
  port: process.env.PORT || 3000,
  maintenance: false,
  apiProxyUrl: '',
  universalLoginApiUrl: '',
  envPrefix: '',
  isSecured: true,
  app: {
    title: 'Stingray Login',
    description: 'Login App for Stingray.',
    head: {
      title: 'Stingray Login',
      meta: [{ name: 'description', content: 'Login App for Stingray.' }, { charset: 'utf-8' }, { property: 'og:site_name', content: 'Universal Login' }, { property: 'og:locale', content: 'en_US' }, { property: 'og:title', content: 'Universal Login' }, { property: 'og:description', content: 'Login App for Stingray.' }]
    }
  },
  supportEmail: {}
}, environment);


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 51
// module chunks = 0